import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, convertStringToArray } from '../../../utils';
// constant
// restClient
import { aemHostClient, eapiClient } from '../../../restClient';
// children
import CaseMenu from '../../common/CaseMenu/CaseMenu';
import Filter from './Grid/Filter';
import ReactTable from './Grid/Table/';
//action Creator
import { setDarkTitleBarContent } from '../../layouts/actions/actionCreator';
//style
import './Grid/Table/index.css';
import './index.css';

class CaseHistory extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      entityData: [],
      eventType: "All events",
      userType: "All users"
    };
  }

  loadData = () => {
    /*let caseOwner = [
      {
        "id":"All Users",
        "value":"All Users"
      },
      {
        "id": this.props.darkTitleBar.currentCase.caseOwner.name,
        "value":  this.props.darkTitleBar.currentCase.caseOwner.name
      }
    ]*/
    let url;
    if (this.props.history.location.pathname.includes("sow-body")) {
      let sowId = this.props.match.params.sowId
      url = `/sows/${sowId}/sowHistory`;
    }
    else {
      let caseId = this.props.match !== undefined ? this.props.match.params.Urn : this.props.caseId;

      url = `/cases/${caseId}/caseHistory`;
    }

    let langParam = '';

    if (this.props.lang.currentLang.lang === "Spanish") {
      langParam = '?lang=es';
    } else if (this.props.lang.currentLang.lang === "Bahasa") {
      langParam = '?lang=ba';
    }

    eapiClient(url + langParam)
      .then(({ data }) => {
        let usersList = [];
        Object.keys(data.responseData.data.users).map(key => {
          usersList[key] = {
            "id": data.responseData.data.users[key],
            "value": data.responseData.data.users[key]
          }
        });
        usersList.unshift({
          id: "All users",
          value: "All users"
        });
        let historyData = [];
        if (this.props.history.location.pathname.includes("sow-body")) {
          historyData = data.responseData.data.sowHistory
        }
        else {
          historyData = data.responseData.data.caseHistory
        }

        this.setState({
          data: historyData || [],
          filterData: historyData || [],
          caseOwner: usersList || [],
          eventStatus: data.responseData.eventType,
          entityData: historyData || []
        });
      });

  }

  componentWillReceiveProps(nextProps) {
    let url;
    if (this.props.history.location.pathname.includes("sow-body")) {
      let sowId = this.props.match.params.sowId
      url = `/sows/${sowId}/sowHistory`;
    }
    else {
      let caseId = this.props.match !== undefined ? this.props.match.params.Urn : this.props.caseId;

      url = `/cases/${caseId}/caseHistory`;
    }
    let langParam = '';

    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      if (nextProps.lang.currentLang.lang === 'Spanish') {
        langParam = '?lang=es';
      } else if (nextProps.lang.currentLang.lang === 'Bahasa') {
        langParam = '?lang=ba';
      } else if (nextProps.lang.currentLang.lang === 'English') {
        langParam = '';
      }
      eapiClient(url + langParam)
        .then(({ data }) => {
          let historyData = [];
          if (this.props.history.location.pathname.includes("sow-body")) {
            historyData = data.responseData.data.sowHistory
          }
          else {
            historyData = data.responseData.data.caseHistory
          }
          this.setState({
            eventStatus: data.responseData.eventType,
            entityData: historyData || []
          });
        });
    }
  }

  componentWillMount() {

    aemHostClient("/aemData/formData/json_case-history")
      .then(({ data }) => {
        this.setState({ pageJson: data.par });
        document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`;
      });


    try {
      this.loadData();
      let heading;
      const currentCase = this.props.cases[(Object.keys(this.props.cases))[0]];
      if (Object.keys(this.props.cases).length > 1) {
        const noOfCasesExcludingRoot = Object.keys(this.props.cases).length - 1;
        heading = `${currentCase.entityName} (+${noOfCasesExcludingRoot} others)`;
      } else {
        heading = currentCase.entityName;
      }
      aemHostClient("/aemData/formData/json_dark-title-bar")
        .then(({ data, status }) => {
          this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase, this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-delete", currentCase);
        });
    }
    catch (e) {
    }

  }
  getStatusOnchange = (filter) => {
    this.setState({
      eventType: filter
    })
    if (filter.length > 0 && filter !== 'All events') {
      if (this.state.userType === 'All users') {
        let filteredDataObject = this.state.filterData.filter(caseHistory => {
          return caseHistory.eventType.toLowerCase() === filter.toLowerCase();
        });
        this.setState({
          data: filteredDataObject,
          entityData: filteredDataObject
        });
      } else {
        let filteredDataObject = this.state.filterData.filter(caseHistory => {
          return caseHistory.eventType.toLowerCase() === filter.toLowerCase() && caseHistory.userId.toLowerCase() === this.state.userType.toLowerCase();
        });
        this.setState({
          data: filteredDataObject,
          entityData: filteredDataObject
        });
      }
    } else if (this.state.userType === 'All users' && filter === 'All events') {
      this.setState({
        data: this.state.filterData,
      });
    } else if (filter.length > 0 && filter === 'All events') {
      let filteredDataObject = this.state.filterData.filter(caseHistory => {
        return caseHistory.userId.toLowerCase() === this.state.userType.toLowerCase();
      });
      this.setState({
        data: filteredDataObject,
        entityData: filteredDataObject
      });
    }
  }

  getStatusOnUserchange = (filter) => {
    this.setState({
      userType: filter
    })
    if (filter.length > 0 && filter !== 'All users') {
      if (this.state.eventType === 'All events') {
        let filteredDataObject = this.state.filterData.filter(caseHistory => {
          return caseHistory.userId.toLowerCase() === filter.toLowerCase();
        });
        this.setState({
          data: filteredDataObject,
          entityData: filteredDataObject
        });
      } else {
        let filteredDataObject = this.state.filterData.filter(caseHistory => {
          return caseHistory.eventType.toLowerCase() === this.state.eventType.toLowerCase() && caseHistory.userId.toLowerCase() === filter.toLowerCase();
        });
        this.setState({
          data: filteredDataObject,
          entityData: filteredDataObject
        });
      }
    } else if (filter === 'All users' && this.state.eventType === 'All events') {
      this.setState({
        data: this.state.filterData,
      });
    } else if (filter.length > 0 && filter === 'All users') {
      let filteredDataObject = this.state.filterData.filter(caseHistory => {
        return caseHistory.eventType.toLowerCase() === this.state.eventType.toLowerCase();
      });
      this.setState({
        data: filteredDataObject,
        entityData: filteredDataObject
      });
    }
  }

  columnsHeader = () => {
    let fieldData;
    let confieldData;
    let columns = [];
    if (this.props.history.location.pathname.includes("sow-body")) {
      columns = [
        { accessor: "lastUpdatedOn" },
        {
          id: "sowCaseId",
          accessor: d => d.sowCaseId
        },
        { accessor: "userId" },
        { accessor: "eventType" },
        { accessor: "eventDetail" }
      ]
    } else {
      columns = [
        { accessor: "lastUpdatedOn" },
        {
          id: "caseId",
          accessor: d => d.caseId
        },
        { accessor: "userId" },
        { accessor: "eventType" },
        { accessor: "eventDetail" }
      ]
    }

    if (this.state.pageJson !== '' && this.state.pageJson !== undefined) {

      if (this.props.history.location.pathname.includes("sow-body")) {
        fieldData = Translations(this.state.pageJson.table_caseHistoryTable.sowFieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData)
      } else {
        fieldData = Translations(this.state.pageJson.table_caseHistoryTable.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData)
      }
      confieldData = convertStringToArray(fieldData);
      if (!(Object.keys(this.state.pageJson).length === 0 && this.state.pageJson.constructor === Object)) {
        for (let i = 0; confieldData.length > i; i++) {
          columns[i].Header = confieldData[i];
        }
      }
      return columns;
    }
    return columns;
  }

  goTOCase = (Urn) => {
    try {
      if (this.props.history.location.pathname.includes("sow-body")) {
        this.props.history.push({
          pathname: `/sow-body/`,
          state: { Urn: this.props.history.location.state.Urn }
        });
      } else {
        if (this.props.history.location.state.Urn) {
          this.props.history.push({
            pathname: `/case-body/`,
            state: { Urn: this.props.history.location.state.Urn }
          });
        }
      }

    }
    catch (e) {
      if (Urn !== undefined) {
        this.props.history.push({
          pathname: `/case-body/`,
          state: { Urn: Urn }
        });
      } else {
        alert("Wrong Case Id");
      }
    }
  }

  filterByEntity = (caseId) => {
    if (caseId !== 'all') {
      let data = this.state.entityData.filter((item) => {
        return caseId === item.id;
      });
      this.setState({
        data: data
      });
    } else {
      this.setState({
        data: this.state.entityData
      });
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData);
  }

  resetAllData = () => {
    this.loadData();
  }

  render() {
    let styleBtn = {
      marginTop: "3px"
    }
    let tablejsx = (<h3>Loading...</h3>);
    let tableFilter = (<h3>Loading...</h3>);
    let pageJsx;
    if (this.state.pageJson !== '' &&
      this.state.pageJson !== undefined) {
      tableFilter = (
        <Filter
          pageJson={this.state.pageJson}
          eventStatus={this.state.eventStatus}
          caseOwner={this.state.caseOwner}
          getStatusOnchange={(str) => this.getStatusOnchange(str)}
          getStatusOnUserchange={(str) => this.getStatusOnUserchange(str)}
          entitiesList={this.props.entitiesList}
          cases={this.props.cases}
          filterByEntity={(caseId) => this.filterByEntity(caseId)}
          lang={this.props.lang}
          resetAllData={this.resetAllData}
        />);
    }

    tablejsx = (
      <ReactTable
        data={this.state.data}
        pageJsonContent={this.state.pageJson}
        columns={this.columnsHeader()}
        lang={this.props.lang}
      />
    );
    if (this.state.pageJson !== undefined) {
      pageJsx = <fragment><div className="gdoc-case-history-container">
        <div className="gdoc-case-history" >
          <h2 className="headingTitle">{this.translations(this.props.history.location.pathname.includes("sow-body") ? this.state.pageJson.page_title_mainTitle.sowPageHeading : this.state.pageJson.page_title_mainTitle.pageHeading)}</h2>
          {tableFilter}
          {tablejsx}
        </div>
        <div className="gdoc-case-history-case-menu">
          <CaseMenu
            history={this.props.history}
            lang={this.props.lang}
            sow={this.props.history.location.pathname.includes("sow-body") ? true : false}
            sowEntities={this.props.sowEntities}
          />
        </div>
      </div>
        <div style={styleBtn} className="history-footer-btn">
          <button
            type="button"
            className="gdocs-btn-primary case-history-btn"
            onClick={() => this.goTOCase(this.props.Urn)}
            name="supportingDoc"
          >
            {this.translations(this.props.history.location.pathname.includes("sow-body") ? this.state.pageJson.button_returnToSOW.text : this.state.pageJson.button_returnToCase.text)}
          </button>
        </div>
      </fragment>
    }

    var renderedCaseList = pageJsx

    return (
      (
        this.state.pageJson !== undefined
          ? renderedCaseList
          : ''
      )
    );
  }
}

const mapStateToProps = state => {
  let entitiesList = [];
  entitiesList = (Object.keys(state.entities)).map(entityId => {
    const { caseId, entityName } = state.entities[entityId];
    return { entityId, caseId, entityName };
  });
  entitiesList.unshift({
    caseId: 'all',
    entityName: 'All'
  });
  return {
    cases: state.cases,
    darkTitleBar: state.darkTitleBar,
    entitiesList,
    lang: state.lang,
    sowEntities: (state.sowEntities && state.sowEntities.savedSow && state.sowEntities.savedSow.entity) || []

  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseHistory);


// WEBPACK FOOTER //
// ./src/components/CaseBody/CaseHistory/index.js